<template>
    <form @submit="onSubmit">
        <div class="flex flex-col justify-center space-y-5 font-body">
            <p class="text-sm text-muval-gray-2">
                Search for the order this email belongs to. Moving it removes it from the current order's timeline.
            </p>

            <OrderRefDropdown
                vid="order_id"
                class="w-full"
                placeholder="Search orders by ref or customer"
            />

            <ErrorDetails :errorData="errorObject" />

            <div class="flex">
                <div class="ml-auto flex gap-5">
                    <MuvalButton
                        quaternary
                        type="button"
                        @click.prevent="$emit('cancel:modal')"
                    >
                        Cancel
                    </MuvalButton>
                    <MuvalButton :loading="loading">Move email</MuvalButton>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
import OrderRefDropdown from '@inputs/OrderRefDropdown.vue';
import MuvalButton from '@buttons/MuvalButton.vue';
import ErrorDetails from '@components/errors/ErrorDetails.vue';
import { useForm } from 'vee-validate';
import { toast } from 'vue-sonner';

const props = defineProps({
    itemId: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(['close:modal', 'cancel:modal']);

const errorObject = ref({
    message: null,
    errors: null,
});

const form = reactive(useForm());
const loading = ref(false);

const onSubmit = form.handleSubmit(async (values) => {
    try {
        loading.value = true;
        await window.tenantAxios.patch(`/inbox/${props.itemId}/order`, {
            order_id: values.order_id,
        });
        toast.success('Email moved to the selected order.');
        emit('close:modal');
    } catch (error) {
        errorObject.value.message = error.message;
        errorObject.value.errors = error.errors;
        form.setErrors(error.errors ?? {});
    } finally {
        loading.value = false;
    }
});
</script>
